var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.subColumn)?_c('div',[(_vm.item[_vm.column])?_c('div',[_vm._v(_vm._s(_vm.item[_vm.column][_vm.subColumn]))]):_vm._e()]):_c('div',{staticClass:"px-2 py-1"},[_vm._v(_vm._s(_vm.item[_vm.column]))])}
var staticRenderFns = []

export { render, staticRenderFns }